import { Link, makeStyles, Typography } from "@material-ui/core";
import { useTranslate } from "ra-core";
import { FC } from "react";
import { IMenuLink, MenuProps } from "../../types";
import CustomTitle from "../layout/CustomTitle";
import Menu from "../layout/Menu";
import CustomLayoutPage from "./CustomLayoutPage";

interface ContactTranspowerProps {
  appname: string;
  email: string;
  subject: string;
  links?: Array<IMenuLink>;
}

const useStyles = makeStyles((theme) => ({
  linkText: {
    fontSize: "1rem",
    fontFamily: "Roboto, Helvetica, Arial",
  },
}));

export const ContactTranspower: FC<ContactTranspowerProps> = ({
  links,
  appname,
  subject,
  email,
  ...props
}) => {
  const translate = useTranslate();
  const classes = useStyles();

  const emailAddress = translate(email);
  const subjectLine = subject
    ? `?subject=${encodeURIComponent(translate(subject))}`
    : "";

  const menu = (props: MenuProps) => {
    return Menu({ links, hideResources: true, hideDashboard: true, ...props });
  };

  return (
    <CustomLayoutPage appname={appname} menu={menu} {...props}>
      <>
        <CustomTitle title={"portal.title.contactTranspower"} />
        <Typography gutterBottom variant="h4">
          {translate("portal.title.contactTranspower")}
        </Typography>
        <Typography gutterBottom>
          {translate("portal.messages.contactTranspower")}
          <Link
            className={classes.linkText}
            href={`mailto:${emailAddress}${subjectLine}`}
            underline={"always"}
          >
            {emailAddress}
          </Link>
        </Typography>
      </>
    </CustomLayoutPage>
  );
};

export default ContactTranspower;
